import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigationItems = [
    { label: 'SmartFix', path: '/smart-fix', icon: 'Zap' },
    { label: 'Breakdown Analytics', path: '/work-order-analytics', icon: 'BarChart3' },
    { label: 'Settings', path: '/settings', icon: 'Settings' }
  ];

  const isActive = (path) => location?.pathname === path;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <header className="sticky top-0 z-50 w-full border-b border-border/40 bg-white/80 dark:bg-gray-900/80 backdrop-blur-3xl shadow-sm">
        <div className="container mx-auto px-6 lg:px-8">
          <div className="flex h-20 items-center justify-between">
            {/* Logo Section - Clean, No Background */}
            <Link to="/" className="flex items-center gap-3 group transition-all duration-300 hover:opacity-80">
              <img 
                src="/assets/images/image-1769588520818.png" 
                alt="Clarity AI Logo" 
                className="w-10 h-10 object-contain transition-transform duration-300 group-hover:scale-105"
              />
              <div className="flex flex-col">
                <span className="text-2xl font-bold bg-gradient-to-r from-gray-900 via-gray-800 to-gray-700 dark:from-gray-100 dark:via-gray-200 dark:to-gray-300 bg-clip-text text-transparent tracking-tight">Clarity AI</span>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-1.5">
              {navigationItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  className={`group relative flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ${
                    isActive(item?.path)
                      ? 'text-primary bg-primary/10' :'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 hover:bg-gray-100/80 dark:hover:bg-gray-800/80'
                  }`}
                >
                  <Icon name={item?.icon} size={18} className="transition-transform duration-200 group-hover:scale-110" />
                  <span>{item?.label}</span>
                  {isActive(item?.path) && (
                    <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-12 h-0.5 bg-primary rounded-full"></div>
                  )}
                </Link>
              ))}
            </nav>

            {/* Mobile Menu Button */}
            <button
              onClick={toggleMobileMenu}
              className="lg:hidden p-2.5 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-800 transition-all duration-200"
              aria-label="Toggle mobile menu"
              aria-expanded={isMobileMenuOpen}
            >
              <Icon name={isMobileMenuOpen ? 'X' : 'Menu'} size={24} />
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden fixed inset-0 z-40 bg-white/95 dark:bg-gray-900/95 backdrop-blur-2xl animate-in fade-in slide-in-from-top-4 duration-300">
          <div className="container mx-auto px-6 pt-24 pb-8">
            <nav className="flex flex-col gap-2">
              {navigationItems?.map((item, index) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  className={`group flex items-center gap-3 px-5 py-4 rounded-xl text-base font-medium transition-all duration-200 animate-in slide-in-from-left-8 fade-in ${
                    isActive(item?.path)
                      ? 'bg-primary/10 text-primary' :'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
                  }`}
                  onClick={() => setIsMobileMenuOpen(false)}
                  style={{ animationDelay: `${index * 50}ms` }}
                >
                  <div className={`w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-200 ${
                    isActive(item?.path)
                      ? 'bg-primary/20' :'bg-gray-100 dark:bg-gray-800 group-hover:bg-primary/10'
                  }`}>
                    <Icon name={item?.icon} size={20} className={isActive(item?.path) ? 'text-primary' : 'text-gray-600 dark:text-gray-400'} />
                  </div>
                  <span className="flex-1">{item?.label}</span>
                  {isActive(item?.path) && (
                    <div className="w-2 h-2 rounded-full bg-primary"></div>
                  )}
                </Link>
              ))}
            </nav>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;